import { createSelector } from 'reselect';
import { defaultState } from './reducer';

const selectReportsPageDomain = state => state.notifications || defaultState;

const getNotificationSelector = () => createSelector(selectReportsPageDomain, ({ notifications }) => notifications);

export { getNotificationSelector };
